export default class OrderInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}